import {
  AUTOFILL_PROPERTY_DATA_API,
  AutofillPropertyDataRequest,
  PropertyData,
  autofillProperty,
} from '@aloft/toolkit-shared';

import { fetchAutofillPropertyData } from './api/toolkitComponents.ts';
import { useToolkitContext } from './api/toolkitContext.ts';

export const useAutofillProperty = () => {
  const { fetcherOptions } = useToolkitContext();
  return async (request: AutofillPropertyDataRequest): Promise<PropertyData> => {
    try {
      const response = await fetchAutofillPropertyData({
        ...fetcherOptions,
        body: AUTOFILL_PROPERTY_DATA_API.POST.REQUEST.BODY.parse(request),
      });
      return AUTOFILL_PROPERTY_DATA_API.POST.RESPONSE.parse(response).result;
    } catch (e: unknown) {
      console.error(e, 'Failed autofill');

      if (!request.address) {
        throw new Error('No property found from MLS listing');
      }

      return autofillProperty({
        address: request.address,
        effectiveYear: request.effectiveYear,
        sources: { xml: request.xmlProperty },
      });
    }
  };
};
